// Vite 8's Rolldown pre-bundler wraps CJS modules differently than Vite 5's
// esbuild. For lottie-react, the default import resolves to the module object
// { default: LottieComponent, useLottie, ... } instead of the component itself.
// This re-export unwraps it so consumers can just import Lottie normally.

import _Lottie from "lottie-react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
export const Lottie = (_Lottie as any).default ?? _Lottie;
